import React, { useState, useEffect, useCallback } from 'react';
import { RefreshCw } from 'lucide-react';
import { api, inr } from '../api';

export default function TargetModule({ agent }) {
  const [b, setB] = useState(null);

  const load = useCallback(() => api.get(`/brownie/${agent.id}`).then((r) => setB(r.data)), [agent.id]);
  useEffect(() => { load(); }, [load]);

  if (!b) return <p className="font-hand text-lg text-orange-800/60 text-center py-4">Loading your mission…</p>;

  if (!b.target) {
    return (
      <div className="text-center py-4" data-testid="target-widget">
        <p className="text-4xl mb-1">🎯</p>
        <p className="font-hand text-xl text-orange-800/80 font-bold">No target set yet!</p>
        <p className="text-[11px] text-orange-700/60 mt-1">Ask Admin to set your daily target — brownie points await 🍫</p>
      </div>
    );
  }

  const prog = Math.min(b.progress, 100);
  const above = b.points >= 0;
  const msg = b.progress >= 100 ? 'TARGET SMASHED! You legend 🎉'
    : b.progress >= 75 ? 'So close — one big sale away! 🔥'
    : b.progress >= 40 ? 'Halfway hero — keep dialing 💪'
    : 'Fresh day, fresh hustle ☕';

  return (
    <div data-testid="target-widget" className="space-y-2.5">
      <div className="flex items-center justify-between">
        <p className="font-hand text-lg text-orange-900/80 font-bold">Today's mission 🎯</p>
        <div className="flex items-center gap-1.5">
          <span className="text-[9px] font-bold uppercase tracking-wider text-orange-700/50" data-testid="days-present-chip">{b.days_present}d present · {b.month}</span>
          <button data-testid="target-refresh" onClick={load} className="p-1 rounded-full hover:bg-orange-100 text-orange-700"><RefreshCw size={12} /></button>
        </div>
      </div>

      <div className="bg-white/80 border border-orange-200 rounded-lg px-3 py-2 text-center">
        <p className="font-display font-extrabold text-2xl text-orange-950" data-testid="target-achieved">{inr(b.achieved)}</p>
        <p className="text-[10px] font-bold uppercase tracking-wider text-orange-700/60">of {inr(b.target)} daily target · {b.progress}%</p>
      </div>

      <div className="relative pt-4 pb-1 px-1">
        <div className="h-4 rounded-full bg-orange-100 border border-orange-200 overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-1000"
            style={{ width: `${prog}%`, background: b.progress >= 100 ? 'linear-gradient(90deg,#F59E0B,#FDE047)' : 'linear-gradient(90deg,#FB923C,#F59E0B)' }}
          />
        </div>
        <span className="absolute -top-0.5 text-xl transition-all duration-1000" style={{ left: `calc(${prog}% - 12px)` }}>🚀</span>
        <span className="absolute right-0 -top-0.5 text-base">🎯</span>
      </div>

      <div
        data-testid="brownie-points-chip"
        className={`rounded-xl px-3 py-2.5 text-center border-2 ${above ? 'bg-emerald-50 border-emerald-300' : 'bg-red-50 border-red-300'}`}
      >
        <p className={`font-display font-extrabold text-2xl ${above ? 'text-emerald-700' : 'text-red-600'}`}>
          {above ? '🍫 +' : '🍩 '}{b.points.toLocaleString('en-IN')} <span className="text-sm">Brownie Points</span>
        </p>
        <p className={`text-[10px] font-semibold ${above ? 'text-emerald-600' : 'text-red-500'}`}>
          {above
            ? `Month total — each login day scored vs daily target (${b.brownie_pct}%)`
            : `${inr(Math.max(b.target - b.achieved, 0))} left today — points recover as you sell (${b.brownie_pct}%)`}
        </p>
        {b.redeemed > 0 && (
          <p className="text-[10px] font-bold text-violet-600 mt-1" data-testid="redeemed-line">
            🎁 Redeemed {Math.round(b.redeemed).toLocaleString('en-IN')} pts · Balance {Math.round(b.balance).toLocaleString('en-IN')}
          </p>
        )}
      </div>

      <p className="font-hand text-lg text-orange-900/80 text-center font-bold">{msg}</p>
    </div>
  );
}
